// AddRecurringBill.tsx  (supabase-js v2)
import { useEffect, useState } from 'react';
import { supabase } from '../../supabase';


export default function Recurring() {
    const [store, setStore] = useState('');
    const [amount, setAmount] = useState('');
    const [paymentType, setpaymentType] = useState('');
    const [day, setDay] = useState(1);
    const [bills, setBills] = useState([]);
    const [loading, setLoading] = useState(true);


    async function handleSubmit(e) {
        e.preventDefault();
        const {
            data: { session },
        } = await supabase.auth.getSession();
        if (!session) {
            alert('Please sign in');
            return;
        }

        const { error } = await supabase.from('recurring_bills').insert({
            user_id: session.user.id,
            supplier_name: store,
            total_amount: Number(amount),
            purchase_time: day,
            payment_type: paymentType
        });



        if (error) alert(error.message);
        else {
            setStore('');
            setAmount('');
            setDay(1);
            alert('Recurring bill saved!');
            window.location.reload()
        }
    }

    /* ───────── Toggle active / inactive ───────── */
    async function toggleActive(id, currentState) {
        // optimistic UI
        setBills(prev =>
            prev.map(b => (b.id === id ? { ...b, active: !currentState } : b))
        );

        const { error } = await supabase
            .from('recurring_bills')
            .update({ active: !currentState })
            .eq('id', id);

        if (error) {
            alert('Update failed: ' + error.message);
            // roll back UI
            setBills(prev =>
                prev.map(b => (b.id === id ? { ...b, active: currentState } : b))
            );
        }
    }






    /* ───────── Fetch this user’s recurring bills ───────── */
    useEffect(() => {
        let ignore = false;

        async function fetchBills() {
            const { data: { session } } = await supabase.auth.getSession();
            if (!session) { setLoading(false); return; }

            const { data, error } = await supabase
                .from('recurring_bills')
                .select('*')
                .eq('user_id', session.user.id)
                .order('purchase_time');

            if (!ignore) {
                if (error) console.error(error);
                else setBills(data);
                setLoading(false);
            }
        }
        fetchBills();
        return () => { ignore = true; };
    }, [bills.length]);


    if (loading) return <p>Loading…</p>;
    // if (!bills.length) return <p>No recurring bills yet.</p>;

    return (
        <>
            <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-navbarbg="skin6" data-sidebartype="full"
                data-sidebar-position="fixed" data-header-position="fixed">
                <div
                    class="position-relative overflow-hidden text-bg-light min-vh-100 d-flex align-items-center justify-content-center">
                    <div class="d-flex align-items-center justify-content-center w-100">
                        <div class="row justify-content-center w-100">
                            <div class="col-md-8 col-lg-6 col-xxl-3">
                                <div class="card mb-0">
                                    <div class="card-body">
                                        <p class="text-center">Add Recurring Bills</p>
                                        <form onSubmit={handleSubmit} >
                                            <div class="mb-3">
                                                <label for="exampleInputEmail1" class="form-label">Supplier Name</label>
                                                <input class="form-control" value={store} onChange={e => setStore(e.target.value)} required />

                                            </div>
                                            <div class="mb-3">
                                                <label for="exampleInputEmail1" class="form-label">Total Amount</label>
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    class="form-control"
                                                    value={amount}
                                                    onChange={e => setAmount(e.target.value)}
                                                    required
                                                />

                                            </div>
                                            <div class="mb-4">
                                                <label for="exampleInputEmail1" class="form-label">Day of month</label>
                                                <input
                                                    type="number"
                                                    className='form-control'
                                                    min="1"
                                                    max="28"
                                                    value={day}
                                                    onChange={e => setDay(Number(e.target.value))}
                                                    required
                                                />
                                            </div>

                                            <div class="mb-4">
                                                <label for="exampleInputEmail1" class="form-label">Payment Type</label>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    value={paymentType}
                                                    onChange={e => setpaymentType(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div class="d-flex align-items-center justify-content-center">
                                                <button className="btn bg-dark text-white">Save recurring bill</button>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {bills.length && (

                <div className="container table-responsive">
                    <table className="table align-middle text-dark mb-5">
                        <thead className="thead-light">
                            <tr>
                                <th>id</th>
                                <th>Supplier Name</th>
                                <th className="text-end">Amount</th>
                                <th className="text-center">Day of month</th>
                                <th className="text-center">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bills.map((bill, ind) => (
                                <tr key={bill.id}>
                                    <td>{ind + 1}</td>
                                    <td>{bill.supplier_name}</td>
                                    <td className="text-end">${bill.total_amount}</td>
                                    <td className="text-center">{bill.purchase_time}</td>
                                    <td className="text-center">
                                        <button
                                            className={
                                                `btn btn-sm rounded-pill ` +
                                                (bill.active ? 'btn-success' : 'btn-outline-secondary')
                                            }
                                            onClick={() => toggleActive(bill.id, bill.active)}
                                        >
                                            {bill.active ? 'Active' : 'Inactive'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            )}

        </>


    );
}
